import { useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export function useScrollToSection() {
  const navigate = useNavigate();
  const location = useLocation();

  return useCallback((to) => {
    // If we're not on the home page and trying to navigate to a section
    if (location.pathname !== '/' && to.startsWith('/#')) {
      // Navigate to home first
      navigate('/');
      // Wait for navigation to complete
      setTimeout(() => {
        const elementId = to.replace('/#', '');
        const element = document.getElementById(elementId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
      return;
    }

    // If we're already on home page and navigating to a section
    if (to.startsWith('/#')) {
      const elementId = to.replace('/#', '');
      const element = document.getElementById(elementId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      return;
    }

    // For regular page navigation
    navigate(to);
  }, [navigate, location.pathname]);
}